export const useCheckUserLoggedIn = () => {
  const isUserLoggedIn = !!localStorage.getItem('@accessToken');
  return { isUserLoggedIn };
};
